import React, { forwardRef, useRef, useState, useCallback, useEffect, useImperativeHandle } from 'react';

//* HOC's
import { withUIContext } from 'context';

//* Components
import Icon from 'components/common/Icon';

//* Style
import VideoStyle from './style';

const CustomVideo = forwardRef((props, ref) => {
	//! States
	const [isPlaying, setIsPlaying] = useState(false);

	//! Refs
	const video = useRef();

	useImperativeHandle(ref, () => video.current, []);

	const changePlayParams = useCallback((play) => {
		if (video && video.current) {
			if (play) {
				video.current?.pause();
				setIsPlaying(false);
			} else {
				video.current.playsInline = true;
				video.current?.play();
				setIsPlaying(true);
			}
		}
	}, []);

	const handleVideoButtonClick = useCallback(() => {
		changePlayParams(isPlaying);
	}, [video.current, isPlaying]);

	useEffect(() => {
		if (!props.autoplay && !props.play) {
			video.current.pause();
		}
	}, []);

	useEffect(() => {
		changePlayParams(!props.play);
	}, [props.play]);

	return (
		<VideoStyle className={`videoCont ${props.className || ''}`}>
			<video
				ref={video}
				playsInline
				loop={props.loop}
				className={`video`}
				poster={props.poster}
				autoPlay={props.autoplay}
				controls={props.controls}
				muted={props.isLandingPage ? false : typeof props.muted !== 'undefined' || true}>
				<source
					src={`${props?.src}#t=0.1`}
					type='video/mp4'
				/>

				<source
					src={`${props?.src}#t=0.1`}
					type='video/webm'
				/>
			</video>

			{!props.autoplay && (
				<Icon
					onClick={handleVideoButtonClick}
					name={`${isPlaying ? 'pause' : 'play'}`}
					className={`${isPlaying ? 'paused' : 'playing'} play-button`}
				/>
			)}
		</VideoStyle>
	);
});

CustomVideo.displayName = 'CustomVideo';

export default withUIContext(CustomVideo, ['isLandingPage']);
